<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<style>
@import "./assets/main.css";
</style>
